export class ArrowAdjustableTextInput {
    constructor(options) {
        this._isApplyingStep = false;
        this.handleKeyDown = async (event) => {
            if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            const currentValue = this.getValue();
            if (!Number.isFinite(currentValue)) {
                return;
            }
            const delta = (event.key === 'ArrowUp' ? 1 : -1) *
                ArrowAdjustableTextInput.getStep(event);
            const nextValue = currentValue + delta;
            this._isApplyingStep = true;
            this.input.value = String(nextValue);
            try {
                await this.applyValue(nextValue);
            }
            finally {
                this._isApplyingStep = false;
                this.focusReplacementInput();
            }
        };
        this.input = options.input;
        this.getValue = options.getValue;
        this.applyValue = options.applyValue;
        this.findReplacementInput = options.findReplacementInput;
        this.input.addEventListener('keydown', this.handleKeyDown);
    }
    get isApplyingStep() {
        return this._isApplyingStep;
    }
    static getStep(event) {
        if (event.metaKey) {
            return 100;
        }
        if (event.shiftKey) {
            return 10;
        }
        return 1;
    }
    focusReplacementInput() {
        const replacementInput = this.findReplacementInput?.();
        if (!replacementInput) {
            return;
        }
        replacementInput.focus();
        const valueLength = replacementInput.value.length;
        replacementInput.setSelectionRange(valueLength, valueLength);
    }
}
